import {} from 'react-redux';

import { Action } from '@reduxjs/toolkit';

import { PagedResponse } from '../../../../shared/models/paged-response';
import { updateObject } from '../../../../shared/utils';
import { AppAction } from '../../../../store';
import * as actionTypes from '../constants/actionTypes';
import { RabbitSignDocument } from '../../models/rabbit-sign-document';

export interface RabbitSignState {
  error: string | null;
  //todo: remove this comment when when requests from old api will be moved here, and change any to correct model
  rabbitSignTemplate: any | null;
  rabbitSignTemplateLoading: boolean | false;

  rabbitSignTemplatesLookup: any | null;
  rabbitSignTemplatesLookupLoading: any | false;

  saveRabbitSignTemplate: any | null;
  saveRabbitSignTemplateLoading: boolean | false;

  deleteRabbitSignTemplate: any | null;
  deleteRabbitSignTemplateLoading: boolean | false;

  validateRabbitSignSubscription: any | null;
  validateRabbitSignSubscriptionLoading: boolean | false;

  rabbitSignDocuments: PagedResponse<RabbitSignDocument> | null;
  rabbitSignDocumentsLoading: false;
}

const initialState: RabbitSignState = {
  error: null,

  rabbitSignTemplate: null,
  rabbitSignTemplateLoading: false,

  rabbitSignTemplatesLookup: null,
  rabbitSignTemplatesLookupLoading: false,

  saveRabbitSignTemplate: null,
  saveRabbitSignTemplateLoading: false,

  deleteRabbitSignTemplate: null,
  deleteRabbitSignTemplateLoading: false,

  validateRabbitSignSubscription: null,
  validateRabbitSignSubscriptionLoading: false,

  rabbitSignDocuments: null,
  rabbitSignDocumentsLoading: false,
};

//#region RabbitSignTemplates

const getRabbitSignTemplatesStart = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    rabbitSignTemplatesLookup: null,
    error: null,
    rabbitSignTemplatesLookupLoading: true,
  });
};

const getRabbitSignTemplatesSuccess = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    rabbitSignTemplatesLookup: action.data,
    error: null,
    rabbitSignTemplatesLookupLoading: false,
  });
};

const getRabbitSignTemplatesError = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    rabbitSignTemplatesLookup: null,
    error: action.error,
    rabbitSignTemplatesLookupLoading: false,
  });
};

const saveRabbitSignTemplateStart = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    saveRabbitSignTemplate: null,
    error: null,
    saveRabbitSignTemplateLoading: true,
  });
};

const saveRabbitSignTemplateSuccess = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    saveRabbitSignTemplate: action.data,
    error: null,
    saveRabbitSignTemplateLoading: false,
  });
};

const saveRabbitSignTemplateError = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    saveRabbitSignTemplate: null,
    error: action.error,
    saveRabbitSignTemplateLoading: false,
  });
};

const deleteRabbitSignTemplateStart = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    deleteRabbitSignTemplate: null,
    error: null,
    deleteRabbitSignTemplateLoading: true,
  });
};

const deleteRabbitSignTemplateSuccess = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    deleteRabbitSignTemplate: action.data,
    error: null,
    deleteRabbitSignTemplateLoading: false,
  });
};

const deleteRabbitSignTemplateError = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    deleteRabbitSignTemplate: null,
    error: action.error,
    deleteRabbitSignTemplateLoading: false,
  });
};

const getRabbitSignTemplateByIdStart = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    rabbitSignTemplate: null,
    error: null,
    rabbitSignTemplateLoading: true,
  });
};

const getRabbitSignTemplateByIdSuccess = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    rabbitSignTemplate: action.data,
    error: null,
    rabbitSignTemplateLoading: false,
  });
};

const getRabbitSignTemplateByIdError = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    rabbitSignTemplate: null,
    error: action.error,
    rabbitSignTemplateLoading: false,
  });
};

//#endregion RabbitSignTemplates

//#region validateRabbitSignSubscription

const validateRabbitSignSubscriptionStart = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    validateRabbitSignSubscription: null,
    error: null,
    validateRabbitSignSubscriptionLoading: true,
  });
};

const validateRabbitSignSubscriptionSuccess = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    validateRabbitSignSubscription: action.data,
    error: null,
    validateRabbitSignSubscriptionLoading: false,
  });
};

const validateRabbitSignSubscriptionError = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    se: null,
    error: action.error,
    validateRabbitSignSubscriptionLoading: false,
  });
};

//#endregion validateRabbitSignSubscription

const searchRabbitSignDocumentsStart = (state: RabbitSignState, action: AppAction<PagedResponse<RabbitSignDocument>>) => {
  return updateObject(state, {
    rabbitSignDocuments: null,
    error: null,
    rabbitSignDocumentsLoading: true,
  });
};

const searchRabbitSignDocumentsSuccess = (state: RabbitSignState, action: AppAction<PagedResponse<RabbitSignDocument>>) => {
  return updateObject(state, {
    rabbitSignDocuments: action.data,
    error: null,
    rabbitSignDocumentsLoading: false,
  });
};

const searchRabbitSignDocumentsError = (state: RabbitSignState, action: AppAction<PagedResponse<RabbitSignDocument>>) => {
  return updateObject(state, {
    rabbitSignDocuments: null,
    error: action.error,
    rabbitSignDocumentsLoading: false,
  });
};

const refreshRabbitSignDocumentStart = (state: RabbitSignState, action: AppAction<RabbitSignDocument>) => {
  return updateObject(state, {
    error: null,
    rabbitSignDocumentsLoading: true,
  });
};

const refreshRabbitSignDocumentSuccess = (state: RabbitSignState, action: AppAction<RabbitSignDocument>) => {
  return updateRabbitSignDocumentsStateIfSuccess(state, action);
};

const refreshRabbitSignDocumentError = (state: RabbitSignState, action: AppAction<RabbitSignDocument>) => {
  return updateObject(state, {
    error: action.error,
    rabbitSignDocumentsLoading: false,
  });
};

const sendRabbitSignDocumentReminderStart = (state: RabbitSignState, action: AppAction<RabbitSignDocument>) => {
  return updateObject(state, {
    error: null,
    rabbitSignDocumentsLoading: true,
  });
};

const sendRabbitSignDocumentReminderSuccess = (state: RabbitSignState, action: AppAction<RabbitSignDocument>) => {
  return updateRabbitSignDocumentsStateIfSuccess(state, action);
};

const sendRabbitSignDocumentReminderError = (state: RabbitSignState, action: AppAction<RabbitSignDocument>) => {
  return updateObject(state, {
    error: action.error,
    rabbitSignDocumentsLoading: false,
  });
};

const cancelRabbitSignDocumentStart = (state: RabbitSignState, action: AppAction<RabbitSignDocument>) => {
  return updateObject(state, {
    error: null,
    rabbitSignDocumentsLoading: true,
  });
};

const cancelRabbitSignDocumentSuccess = (state: RabbitSignState, action: AppAction<RabbitSignDocument>) => {
  return updateRabbitSignDocumentsStateIfSuccess(state, action);
};

const cancelRabbitSignDocumentError = (state: RabbitSignState, action: AppAction<RabbitSignDocument>) => {
  return updateObject(state, {
    error: action.error,
    rabbitSignDocumentsLoading: false,
  });
};

const downloadExternalRabbitSignDocumentStart = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    error: null,
    rabbitSignDocumentsLoading: true,
  });
};

const downloadExternalRabbitSignDocumentSuccess = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    error: null,
    rabbitSignDocumentsLoading: false,
  });
};

const downloadExternalRabbitSignDocumentError = (state: RabbitSignState, action: AppAction<any>) => {
  return updateObject(state, {
    error: action.error,
    rabbitSignDocumentsLoading: false,
  });
};

const updateRabbitSignDocumentsStateIfSuccess = (state: RabbitSignState, action: AppAction<RabbitSignDocument>) => {
  const refreshedDoc = action.data;
  const docs = state?.rabbitSignDocuments;

  if (refreshedDoc !== null && docs?.data?.length) {
    const updatedDocs = docs.data.map((d) => (d.id === refreshedDoc?.id ? refreshedDoc : d));
    const refreshedDocs = { ...docs, data: updatedDocs };

    return updateObject(state, {
      rabbitSignDocuments: refreshedDocs,
      error: null,
      rabbitSignDocumentsLoading: false,
    });
  }

  return updateObject(state, {
    rabbitSignDocuments: docs,
    error: null,
    rabbitSignDocumentsLoading: false,
  });
};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case actionTypes.GET_RABBIT_SIGN_TEMPLATES_START:
      return getRabbitSignTemplatesStart(state, action as AppAction<any>);
    case actionTypes.GET_RABBIT_SIGN_TEMPLATES_SUCCESS:
      return getRabbitSignTemplatesSuccess(state, action as AppAction<any>);
    case actionTypes.GET_RABBIT_SIGN_TEMPLATES_FAIL:
      return getRabbitSignTemplatesError(state, action as AppAction<any>);

    case actionTypes.SAVE_RABBIT_SIGN_TEMPLATE_START:
      return saveRabbitSignTemplateStart(state, action as AppAction<any>);
    case actionTypes.SAVE_RABBIT_SIGN_TEMPLATE_SUCCESS:
      return saveRabbitSignTemplateSuccess(state, action as AppAction<any>);
    case actionTypes.SAVE_RABBIT_SIGN_TEMPLATE_FAIL:
      return saveRabbitSignTemplateError(state, action as AppAction<any>);

    case actionTypes.DELETE_RABBIT_SIGN_TEMPLATE_START:
      return deleteRabbitSignTemplateStart(state, action as AppAction<any>);
    case actionTypes.DELETE_RABBIT_SIGN_TEMPLATE_SUCCESS:
      return deleteRabbitSignTemplateSuccess(state, action as AppAction<any>);
    case actionTypes.DELETE_RABBIT_SIGN_TEMPLATE_FAIL:
      return deleteRabbitSignTemplateError(state, action as AppAction<any>);

    case actionTypes.GET_RABBIT_SIGN_TEMPLATE_BY_ID_START:
      return getRabbitSignTemplateByIdStart(state, action as AppAction<any>);
    case actionTypes.GET_RABBIT_SIGN_TEMPLATE_BY_ID_SUCCESS:
      return getRabbitSignTemplateByIdSuccess(state, action as AppAction<any>);
    case actionTypes.GET_RABBIT_SIGN_TEMPLATE_BY_ID_FAIL:
      return getRabbitSignTemplateByIdError(state, action as AppAction<any>);

    case actionTypes.VALIDATE_RABBIT_SIGN_SUBSCRIPTION_START:
      return validateRabbitSignSubscriptionStart(state, action as AppAction<any>);
    case actionTypes.VALIDATE_RABBIT_SIGN_SUBSCRIPTION_SUCCESS:
      return validateRabbitSignSubscriptionSuccess(state, action as AppAction<any>);
    case actionTypes.VALIDATE_RABBIT_SIGN_SUBSCRIPTION_FAIL:
      return validateRabbitSignSubscriptionError(state, action as AppAction<any>);

    case actionTypes.SEARCH_RABBIT_SIGN_DOCUMENTS_START:
      return searchRabbitSignDocumentsStart(state, action as AppAction<PagedResponse<RabbitSignDocument>>);
    case actionTypes.SEARCH_RABBIT_SIGN_DOCUMENTS_SUCCESS:
      return searchRabbitSignDocumentsSuccess(state, action as AppAction<PagedResponse<RabbitSignDocument>>);
    case actionTypes.SEARCH_RABBIT_SIGN_DOCUMENTS_FAIL:
      return searchRabbitSignDocumentsError(state, action as AppAction<PagedResponse<RabbitSignDocument>>);

    case actionTypes.REFRESH_RABBIT_SIGN_DOCUMENT_START:
      return refreshRabbitSignDocumentStart(state, action as AppAction<any>);
    case actionTypes.REFRESH_RABBIT_SIGN_DOCUMENT_SUCCESS:
      return refreshRabbitSignDocumentSuccess(state, action as AppAction<any>);
    case actionTypes.REFRESH_RABBIT_SIGN_DOCUMENT_FAIL:
      return refreshRabbitSignDocumentError(state, action as AppAction<any>);

    case actionTypes.SEND_RABBIT_SIGN_DOCUMENT_REMINDER_START:
      return sendRabbitSignDocumentReminderStart(state, action as AppAction<any>);
    case actionTypes.SEND_RABBIT_SIGN_DOCUMENT_REMINDER_SUCCESS:
      return sendRabbitSignDocumentReminderSuccess(state, action as AppAction<any>);
    case actionTypes.SEND_RABBIT_SIGN_DOCUMENT_REMINDER_FAIL:
      return sendRabbitSignDocumentReminderError(state, action as AppAction<any>);

    case actionTypes.CANCEL_RABBIT_SIGN_DOCUMENT_START:
      return cancelRabbitSignDocumentStart(state, action as AppAction<any>);
    case actionTypes.CANCEL_RABBIT_SIGN_DOCUMENT_SUCCESS:
      return cancelRabbitSignDocumentSuccess(state, action as AppAction<any>);
    case actionTypes.CANCEL_RABBIT_SIGN_DOCUMENT_FAIL:
      return cancelRabbitSignDocumentError(state, action as AppAction<any>);

    case actionTypes.DOWNLOAD_EXTERNAL_RABBIT_SIGN_DOCUMENT_START:
      return downloadExternalRabbitSignDocumentStart(state, action as AppAction<any>);
    case actionTypes.DOWNLOAD_EXTERNAL_RABBIT_SIGN_DOCUMENT_SUCCESS:
      return downloadExternalRabbitSignDocumentSuccess(state, action as AppAction<any>);
    case actionTypes.DOWNLOAD_EXTERNAL_RABBIT_SIGN_DOCUMENT_FAIL:
      return downloadExternalRabbitSignDocumentError(state, action as AppAction<any>);
    default:
      return state;
  }
};

export default reducer;
